"use client"

import { useState, useEffect } from "react"
import { Table } from "antd"
import { Resizable } from "react-resizable"

const ResizableCell = (props) => {
  const { onResize, width, ...restProps } = props
  if (!width) {
    return <th {...restProps} />
  }
  return (
    <Resizable
      width={width}
      height={0}
      handle={
        <span
          className="react-resizable-handle"
          onClick={(e) => {
            e.stopPropagation()
          }}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps} />
    </Resizable>
  )
}

const components = {
  header: {
    cell: ResizableCell,
  },
}

const ExcelTableForImport = (props) => {
  const { columnsData, gridData, rowSelection, sheetName } = props
  const [columns, setColumns] = useState([])
  const [data, setData] = useState([])

  useEffect(() => {
    setColumns(columnsData || [])
    setData(gridData || [])
  }, [columnsData, gridData])

  const handleResize =
    (index) =>
    (e, { size }) => {
      setColumns((columns) => {
        const nextColumns = [...columns]
        nextColumns[index] = {
          ...nextColumns[index],
          width: size.width,
        }
        return nextColumns
      })
    }

  const resizableColumns = columns.map((col, index) => ({
    ...col,
    onHeaderCell: (column) => ({
      width: column.width,
      onResize: handleResize(index),
    }),
  }))

  return (
    <div style={{ padding: "10px" }}>
      <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
        Sheet: {sheetName} ({data.length} records)
      </div>
      <Table
        size="small"
        sticky={true}
        scroll={{ y: "58vh", x: "100%" }}
        columns={resizableColumns}
        components={components}
        dataSource={data}
        pagination={false}
        rowSelection={rowSelection}
      />
    </div>
  )
}

export default ExcelTableForImport
